export const heroData = {
  title: "媚肉之香",
  subtitle: "探索香与肌肤之间最深层的共鸣",
  description: "融合东方香氛美学与肌肤养护精髓，带您踏上一场前所未有的感官之旅，唤醒内在魅力与自信，感受迷人气息的层层绽放。",
  ctaPrimary: "探索香氛系列",
  ctaPrimaryLink: "/category/fragrance",
  ctaSecondary: "了解品牌故事",
  ctaSecondaryLink: "/about",
};

export const brandStory = {
  title: "品牌故事",
  subtitle: "当东方美学遇见现代香氛艺术",
  paragraphs: [
    "媚肉之香，源自对东方香氛文化的深刻理解与敬意。我们相信，真正的魅力不仅来自外表的修饰，更源于肌肤与香气之间微妙的共鸣——那是一种从内而外散发的迷人气息，无法被复制，只能被感知。",
    "每一款媚肉之香的香氛与养护产品，都承载着我们对自然材料的严苛挑选与匠心工艺的极致追求。从沉香木的深邃到白兰花的清雅，从玫瑰精油的浓郁到柑橘的明快，我们用心调配每一个音符，只为唤醒您肌肤最原始的感知力。",
    "媚肉之香不仅是一个香氛品牌，更是一种生活态度的表达——拥抱自己的独特魅力，让香气成为您最动人的语言。",
  ],
};

export const fragranceSeries = [
  {
    id: "frag-1",
    name: "暗夜玫瑰",
    category: "fragrance",
    tag: "经典热卖",
    description: "大马士革玫瑰与乌木的交织，展现出深邃而迷人的东方花香调，如暗夜中绽放的神秘玫瑰，令人沉醉不已。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20dark%20rose%20perfume%20bottle%20with%20deep%20crimson%20and%20black%20aesthetic%20on%20silk%20fabric%20with%20warm%20golden%20accents%2C%20elegant%20product%20photography%20with%20soft%20dramatic%20lighting%2C%20oriental%20luxury%20brand%20aesthetic%2C%20dark%20rich%20background%20with%20subtle%20warm%20glow&width=800&height=1000&seq=fragrance-rose-noir-01&orientation=portrait",
    price: "¥680",
    volume: "50ml",
  },
  {
    id: "frag-2",
    name: "檀韵清音",
    category: "fragrance",
    tag: "新品上市",
    description: "以印度老山檀香为主调，辅以雪松与琥珀，营造出沉静悠远的东方木质调，仿佛置身古寺檀烟，心境澄明。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20sandalwood%20fragrance%20bottle%20with%20minimalist%20warm%20beige%20and%20cream%20tones%20on%20raw%20silk%20texture%2C%20zen%20aesthetic%20with%20natural%20wood%20elements%2C%20clean%20elegant%20product%20photography%2C%20soft%20natural%20light%2C%20peaceful%20composition&width=800&height=1000&seq=fragrance-sandalwood-02&orientation=portrait",
    price: "¥580",
    volume: "50ml",
  },
  {
    id: "frag-3",
    name: "桂月凝香",
    category: "fragrance",
    tag: "限定系列",
    description: "金秋桂花与白茶的诗意邂逅，清甜而不腻，温婉而悠长。如同中秋月下漫步桂花园，一呼一吸皆是温柔。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20osmanthus%20fragrance%20bottle%20with%20soft%20golden%20amber%20tones%20on%20cream%20silk%20fabric%2C%20elegant%20oriental%20aesthetic%20with%20subtle%20floral%20elements%2C%20warm%20autumn%20lighting%2C%20minimalist%20luxury%20product%20photography%2C%20gentle%20romantic%20atmosphere&width=800&height=1000&seq=fragrance-osmanthus-03&orientation=portrait",
    price: "¥780",
    volume: "50ml",
  },
  {
    id: "frag-4",
    name: "兰芷清芬",
    category: "fragrance",
    tag: "",
    description: "白兰花与白芷的纯净组合，带来如清晨露水般清澈的气息。淡雅而持久，适合日常穿戴，宛如一抹不经意的优雅。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20white%20floral%20fragrance%20bottle%20with%20pure%20clean%20aesthetic%20on%20soft%20cream%20linen%2C%20elegant%20minimalist%20product%20photography%20with%20morning%20light%2C%20fresh%20dewy%20atmosphere%2C%20white%20and%20green%20subtle%20accents%2C%20sophisticated%20composition&width=800&height=1000&seq=fragrance-magnolia-04&orientation=portrait",
    price: "¥480",
    volume: "50ml",
  },
];

export const skincareSeries = [
  {
    id: "skin-1",
    name: "沉香润体乳",
    category: "skincare",
    tag: "明星产品",
    description: "蕴含珍贵沉香精华与乳木果油，深层滋养肌肤，令肌肤如丝缎般柔滑，散发淡淡沉木香气。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20body%20lotion%20bottle%20with%20warm%20cream%20and%20gold%20accents%20on%20natural%20linen%20texture%2C%20elegant%20skincare%20product%20photography%2C%20spa%20aesthetic%20with%20soft%20warm%20light%2C%20minimalist%20luxury%20composition%2C%20serene%20atmosphere&width=800&height=1000&seq=skincare-body-lotion-01&orientation=portrait",
    price: "¥360",
    volume: "200ml",
  },
  {
    id: "skin-2",
    name: "玫瑰精华油",
    category: "skincare",
    tag: "口碑之选",
    description: "高纯度大马士革玫瑰精油，配合角鲨烷与维生素E，深层修护肌肤屏障，令肌肤饱满莹润，散发自然光泽。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20facial%20oil%20bottle%20with%20rose%20gold%20and%20blush%20pink%20tones%20on%20soft%20silk%2C%20elegant%20skincare%20product%20photography%2C%20warm%20feminine%20aesthetic%2C%20delicate%20natural%20light%2C%20romantic%20composition&width=800&height=1000&seq=skincare-rose-oil-02&orientation=portrait",
    price: "¥520",
    volume: "30ml",
  },
  {
    id: "skin-3",
    name: "檀香护手霜",
    category: "skincare",
    tag: "",
    description: "以檀香精油为核心，融合蜂蜜与甘油，深层滋润双手，修护干燥粗糙，留下一抹温暖的木质余香。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20hand%20cream%20tube%20with%20warm%20cream%20and%20sandalwood%20aesthetic%20on%20natural%20textured%20surface%2C%20elegant%20minimalist%20product%20photography%2C%20soft%20golden%20lighting%2C%20cozy%20atmosphere%2C%20clean%20composition&width=800&height=1000&seq=skincare-hand-cream-03&orientation=portrait",
    price: "¥180",
    volume: "75ml",
  },
  {
    id: "skin-4",
    name: "桂香身体磨砂",
    category: "skincare",
    tag: "限定系列",
    description: "天然桂花花瓣与细砂糖颗粒，温和去除老废角质，同时散发桂花清香，令沐浴时光成为感官享受。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20body%20scrub%20jar%20with%20golden%20amber%20and%20cream%20tones%20on%20marble%20surface%2C%20elegant%20spa%20product%20photography%2C%20warm%20natural%20light%2C%20osmanthus%20aesthetic%2C%20sophisticated%20minimalist%20composition&width=800&height=1000&seq=skincare-body-scrub-04&orientation=portrait",
    price: "¥320",
    volume: "250g",
  },
];

export const featuredArticles = [
  {
    id: "art-1",
    title: "东方香氛的前世今生：从宫廷御香到现代调香艺术",
    excerpt: "追溯东方香氛千年历史，从汉代博山炉到唐宋熏香文化，看东方香道如何影响当代调香美学。",
    category: "香氛文化",
    date: "2025-12-15",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20incense%20ceremony%20with%20bronze%20censer%20and%20rising%20smoke%2C%20warm%20ambient%20light%2C%20ancient%20aesthetic%20with%20silk%20and%20wood%20elements%2C%20editorial%20photography%20style%2C%20serene%20atmosphere%2C%20cultural%20heritage%20vibe&width=800&height=500&seq=article-incense-history-01&orientation=landscape",
  },
  {
    id: "art-2",
    title: "香氛与情绪：如何用香气调节你的身心状态",
    excerpt: "探索芳香疗法的科学原理，了解不同香调如何影响我们的情绪、记忆与身心状态，找到属于你的香氛密码。",
    category: "芳香生活",
    date: "2025-11-28",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20aromatherapy%20scene%20with%20essential%20oils%20and%20dried%20flowers%20on%20wooden%20table%2C%20warm%20natural%20light%20from%20window%2C%20spa%20wellness%20aesthetic%2C%20calm%20and%20peaceful%20composition%2C%20editorial%20photography&width=800&height=500&seq=article-aromatherapy-02&orientation=landscape",
  },
  {
    id: "art-3",
    title: "秋冬香氛指南：温暖木质调与东方辛香调的搭配艺术",
    excerpt: "秋冬季节如何选择适合自己的温暖香氛？从木质调到辛香调，为你解析最适合寒冷季节的香氛搭配法则。",
    category: "穿搭指南",
    date: "2025-11-10",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20fragrance%20collection%20on%20wool%20scarf%20with%20warm%20candlelight%2C%20cozy%20luxury%20aesthetic%2C%20dark%20wood%20and%20amber%20tones%2C%20editorial%20product%20photography%2C%20intimate%20atmosphere&width=800&height=500&seq=article-winter-fragrance-03&orientation=landscape",
  },
];

export const faqData = [
  {
    question: "媚肉之香的香氛采用什么原料？",
    answer: "媚肉之香的每一款香氛均严选全球优质天然原料，包括大马士革玫瑰、印度老山檀香、金秋桂花、白兰花等天然花卉与木料精华。我们坚持不使用任何人工合成麝香，确保每一缕香气都纯净自然，与肌肤产生最和谐的共鸣。",
  },
  {
    question: "如何挑选适合自己的香氛？",
    answer: "我们建议根据您的性格气质与日常场景来选择。木质调（如檀韵清音）适合沉静内敛的气质，适合职场与正式场合；花香调（如暗夜玫瑰）适合浪漫自信的女性，适合约会与社交场合；清新型（如兰芷清芬）适合活泼灵动的性格，适合日常穿戴。您也可以从我们的香氛体验套装开始，一次尝试多款香调。",
  },
  {
    question: "肌肤养护系列适合什么肤质？",
    answer: "媚肉之香的肌肤养护系列采用温和天然配方，适用于大多数肤质。沉香润体乳适合中性至干性肌肤；玫瑰精华油适用于所有肤质，尤其推荐干燥与初老肌肤使用；檀香护手霜特别适合干燥粗糙的双手。如您有特殊敏感肤质，建议先在手背小范围试用。",
  },
  {
    question: "产品的保质期是多久？",
    answer: "香氛产品未开封状态下保质期为3年，开封后建议在12个月内使用完毕以获得最佳香气体验。肌肤养护产品未开封保质期为2-3年，开封后建议在6-12个月内使用完毕。所有产品请置于阴凉干燥处，避免阳光直射。",
  },
  {
    question: "可以退换货吗？",
    answer: "我们提供7天无理由退换货服务（未开封产品）。如产品存在质量问题，请在收到产品的48小时内联系客服，我们将第一时间为您处理。具体退换货政策请参考我们的服务条款页面。",
  },
];

export const statsData = [
  { value: "50,000+", label: "满意客户" },
  { value: "98%", label: "好评率" },
  { value: "30+", label: "城市覆盖" },
  { value: "12", label: "专利配方" },
];